import React from 'react';
import { Map, TileLayer } from 'react-leaflet'

import { useGeolocationContext } from '../hooks/geolocationContext';

import { VehiclesMapMarkersList } from './VehiclesMapMarkersList';
import { DataUpdateInfo } from './DataUpdateInfo';

// map docs: https://react-leaflet-v2-docs.netlify.app/docs/en/intro
export const GeolocationMap = () => {
	const { position, zoom, onPopupClose } = useGeolocationContext();

	return (
		<div className="map-container">
			<Map center={position} position={position} zoom={zoom} onPopupClose={onPopupClose}>
				<TileLayer
					attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
					url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
				/>
				<VehiclesMapMarkersList />
			</Map>
			<DataUpdateInfo />
		</div>
	)
};
